import { z } from "zod";

/**
 * `?tab=` on the inbox and on the review page (whose pager walks that tab);
 * `?item=` is the document open in the pane beside the inbox list.
 */
export const inboxSearch = z.object({
  tab: z.enum(["needs_you", "ready", "waiting", "posted", "rejected"]).catch("needs_you"),
  upload: z.boolean().optional().catch(undefined),
  item: z.string().min(1).optional().catch(undefined),
});
